<script setup>
    import Layout from "@/layouts/main.vue";
    import PageHeader from "@/components/page-header";
    import '@jobinsjp/vue3-datatable/dist/style.css';
    import { DataTable, TableBody, TableHead, TableBodyCell } from '@jobinsjp/vue3-datatable';
    import { computed, ref, onMounted } from 'vue';
    import { useStore } from 'vuex';
    import axios from 'axios';
    import Swal from 'sweetalert2';

    const store = useStore();
    const loading = computed(() => store.state.globals.loading);
    const lgus = computed(() => store.state.lgu.dropdownLGUs);
    const printManifest = computed(() => store.state.delivery.printManifest);
    const pagination = computed(() => store.state.delivery.printManifestPagination);
    const baseURL = axios.defaults.baseURL;
    const title = ref("Print Manifest");
    const items = ref([
        {
            text: "Home",
            href: "/"
        },
        {
            text: "Delivery",
        },
        {
            text: "Print Manifest",
            active: true,
        }
    ]);

    const query = ref({
        search: ''        
    });

    const getAllPrintManifest = async (dt) => {
        await store.dispatch('delivery/getAllPrintManifest', {
            page: dt.page,
            pageSize: dt.per_page ,
            sortColumn: 'id',
            search: dt.search,
            orderBy: 'desc'
        });
    }

    const markPrintManifestAsPrinted = async (batch_id) => {
      if (!batch_id) return;

      try {
        await store.dispatch('delivery/setPrintManifestPrintStatus', { batch_id } );
      } catch (err) {
        Swal.fire("Failed", `Already printed.`, 'error');
        console.log(err);
      }
    }

    const getLGU = (id) => {
        if (lgus.value.length > 0) {
          const lgu = lgus.value.find((el) => el.id === id);
          return lgu.name;
        }
        return 'N/A';
    }

  onMounted(() => {
    store.dispatch('lgu/getDropdownLGUs')
  })
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <b-overlay :show="loading">
        <div class="d-flex mb-4 justify-content-between">
          <div>
            <h1 class="fs-4 text">Print Manifest</h1>
            <small>Get all the batches</small>
          </div>
        </div>

        <div class="row">
            <div class="col lg-12">
                <data-table
                    :rows="printManifest"
                    :pagination="pagination"
                    striped
                    :loading="loading"
                    :query="query"
                    filter
                    hoverable
                    sortable
                    @loadData="getAllPrintManifest"
                    >

                    <template #thead>
                        <table-head>Batch ID</table-head>
                        <table-head>LGU</table-head>
                        <table-head>Batch No.</table-head>
                        <table-head>Batch Count</table-head>
                        <table-head>Print</table-head>
                    </template>

                    <template #tbody="{row}">
                        <table-body v-text="row.id" />
                        <table-body v-text="getLGU(row.lgu_id)" />
                        <table-body v-text="row.batch_number" />
                        <table-body v-text="row.batch_count" />
                        <table-body>
                          <b-button-group class="mx-1">
                            <a class="btn btn-secondary" :href="`${baseURL}/delivery/print/manifest/${row.id}`">
                              <i class="mdi mdi-printer-check mr-2"></i>
                              Print
                            </a>
                            <b-dropdown right text="" variant="secondary">
                              <b-dropdown-item>
                                <div class="form-check form-switch form-check-inline" dir="ltr">
                                  <input @click="markPrintManifestAsPrinted(row.id)" :disabled="row.batch_print_manifest.is_printed" :checked="row.batch_print_manifest.is_printed" type="checkbox" class="form-check-input" :id="`inlineswitch-${row.batch_print_manifest.id}`">
                                  <label class="form-check-label fs-6 text" :for="`inlineswitch-${row.batch_print_manifest.id}`">{{ !row.batch_print_manifest.is_printed ? 'Mark as Printed' : 'Printed' }}</label>
                                </div>
                              </b-dropdown-item>
                            </b-dropdown>
                          </b-button-group>
                        </table-body>
                    </template>

                    <template #empty>
                    <TableBodyCell colspan="10">
                        No Print Manifest found!
                    </TableBodyCell>
                </template>
                </data-table>
            </div>
        </div>
      </b-overlay>
  </Layout>
</template>